import React, { useEffect, useState, useRef } from 'react'
import { Modal, Button, notification, Icon, Spin } from 'antd';
import { inject, observer } from 'mobx-react'
import {
  isFirefox,
  isIOS
} from "react-device-detect";
import {
  AbsoluteOrientationSensor,
  RelativeOrientationSensor
} from '../../assets/motion-sensors-polyfill/motion-sensors';

import {
  Cartesian3,
  VerticalOrigin,
  PinBuilder,
  Color,
  Matrix4, Cartesian2,
  HeadingPitchRoll, Cartographic, Ellipsoid, Quaternion,
  Math as CesiumMath,
  Cesium3DTileStyle,
  HeadingPitchRange, ScreenSpaceEventHandler,
  ScreenSpaceEventType, Transforms
} from 'cesium'
import { Entity } from 'resium'
import { createImageFileFromBase64, rotateCamera, getCenterScreenCoordinates } from '../helper/CesiumUtils'
import { ProjectRequest } from '../../requests'
import { toJS } from 'mobx'
// import { FULLTILT } from 'fulltilt-ng';
import { clickPoint } from '../helper/CesiumUtils'
import { Trans, useTranslation } from 'react-i18next';
/**
 *
 * FULL TILT
 * http://github.com/richtr/Full-Tilt
 *
 * A standalone DeviceOrientation + DeviceMotion JavaScript library that
 * normalises orientation sensor input, applies relevant screen orientation
 * transforms, returns Euler Angle, Quaternion and Rotation
 * Matrix representations back to web developers and provides conversion
 * between all supported orientation representation types.
 *
 * Copyright: 2014 Rich Tibbett
 * License:   MIT
 *
 */

(function (window) {

  // Only initialize the FULLTILT API if it is not already attached to the DOM
  if (window.FULLTILT !== undefined && window.FULLTILT !== null) {
    return;
  }

  var M_PI = Math.PI;
  var M_PI_2 = M_PI / 2;
  var M_2_PI = 2 * M_PI;

  // Degree to Radian conversion
  var degToRad = M_PI / 180;
  var radToDeg = 180 / M_PI;

  // Internal device orientation + motion variables
  var sensors = {
    "orientation": {
      active: false,
      callbacks: [],
      data: undefined
    },
    "motion": {
      active: false,
      callbacks: [],
      data: undefined
    }
  };
  var screenActive = false;

  // Internal screen orientation variables
  var hasScreenOrientationAPI = window.screen && window.screen.orientation && window.screen.orientation.angle !== undefined && window.screen.orientation.angle !== null ? true : false;
  var screenOrientationAngle = (hasScreenOrientationAPI ? window.screen.orientation.angle : (window.orientation || 0)) * degToRad;

  var SCREEN_ROTATION_0 = 0,
    SCREEN_ROTATION_90 = M_PI_2,
    SCREEN_ROTATION_180 = M_PI,
    SCREEN_ROTATION_270 = M_2_PI / 3,
    SCREEN_ROTATION_MINUS_90 = - M_PI_2;

  // Math.sign polyfill
  function sign(x) {
    x = +x; // convert to a number
    if (x === 0 || isNaN(x))
      return x;
    return x > 0 ? 1 : -1;
  }

  ///// Promise-based Sensor Data checker //////

  function SensorCheck(sensorRootObj) {

    var promise = new Promise(function (resolve, reject) {

      var runCheck = function (tries) {

        setTimeout(function () {

          if (sensorRootObj && sensorRootObj.data) {

            resolve();

          } else if (tries >= 20000) {

            reject();

          } else {

            runCheck(++tries);

          }

        }, 50);

      };

      runCheck(0);

    });

    return promise;

  }

  ////// Internal Event Handlers //////

  function handleScreenOrientationChange() {

    if (hasScreenOrientationAPI) {

      screenOrientationAngle = (window.screen.orientation.angle || 0) * degToRad;

    } else {

      screenOrientationAngle = (window.orientation || 0) * degToRad;

    }

  }

  function handleDeviceOrientationChange(event) {
    sensors.orientation.data = event;

    // Fire every callback function each time deviceorientation is updated
    for (var i in sensors.orientation.callbacks) {

      sensors.orientation.callbacks[i].call(this);

    }

  }

  function handleDeviceMotionChange(event) {

    sensors.motion.data = event;

    // Fire every callback function each time devicemotion is updated
    for (var i in sensors.motion.callbacks) {

      sensors.motion.callbacks[i].call(this);

    }

  }

  ///// FULLTILT API Root Object /////

  var FULLTILT = {};

  FULLTILT.version = "0.5.3";

  ///// FULLTILT API Root Methods /////

  FULLTILT.getDeviceOrientation = function (options) {

    var promise = new Promise(function (resolve, reject) {

      var control = new FULLTILT.DeviceOrientation(options);

      control.start();
      resolve(control);
      //var orientationSensorCheck = new SensorCheck(sensors.orientation);

      // orientationSensorCheck.then(function() {

      //   resolve(control);

      // }).catch(function() {

      //   control.stop();
      //   reject('DeviceOrientation is not supported');

      // });

    });

    return promise;

  };

  FULLTILT.getDeviceMotion = function (options) {

    var promise = new Promise(function (resolve, reject) {

      var control = new FULLTILT.DeviceMotion(options);

      control.start();

      var motionSensorCheck = new SensorCheck(sensors.motion);

      motionSensorCheck.then(function () {

        resolve(control);

      }).catch(function () {

        control.stop();
        reject('DeviceMotion is not supported');

      });

    });

    return promise;

  };


  ////// FULLTILT.Quaternion //////

  FULLTILT.Quaternion = function (x, y, z, w) {

    var quat, outQuat;

    this.set = function (x, y, z, w) {

      this.x = x || 0;
      this.y = y || 0;
      this.z = z || 0;
      this.w = w || 1;

    };

    this.copy = function (quaternion) {

      this.x = quaternion.x;
      this.y = quaternion.y;
      this.z = quaternion.z;
      this.w = quaternion.w;

    };

    this.setFromEuler = (function () {

      var _x, _y, _z;
      var _x_2, _y_2, _z_2;
      var cX, cY, cZ, sX, sY, sZ;

      return function (euler) {

        euler = euler || {};

        _z = (euler.alpha || 0) * degToRad;
        _x = (euler.beta || 0) * degToRad;
        _y = (euler.gamma || 0) * degToRad;

        _z_2 = _z / 2;
        _x_2 = _x / 2;
        _y_2 = _y / 2;

        cX = Math.cos(_x_2);
        cY = Math.cos(_y_2);
        cZ = Math.cos(_z_2);
        sX = Math.sin(_x_2);
        sY = Math.sin(_y_2);
        sZ = Math.sin(_z_2);

        this.set(
          sX * cY * cZ - cX * sY * sZ, // x
          cX * sY * cZ + sX * cY * sZ, // y
          cX * cY * sZ + sX * sY * cZ, // z
          cX * cY * cZ - sX * sY * sZ  // w
        );

        this.normalize();

        return this;

      };

    })();

    this.setFromRotationMatrix = (function () {

      var R;

      return function (matrix) {

        R = matrix.elements;

        this.set(
          0.5 * Math.sqrt(1 + R[0] - R[4] - R[8]) * sign(R[7] - R[5]), // x
          0.5 * Math.sqrt(1 - R[0] + R[4] - R[8]) * sign(R[2] - R[6]), // y
          0.5 * Math.sqrt(1 - R[0] - R[4] + R[8]) * sign(R[3] - R[1]), // z
          0.5 * Math.sqrt(1 + R[0] + R[4] + R[8])                        // w
        );

        return this;

      };

    })();

    this.multiply = function (quaternion) {

      outQuat = FULLTILT.Quaternion.prototype.multiplyQuaternions(this, quaternion);
      this.copy(outQuat);

      return this;

    };

    this.rotateX = function (angle) {

      outQuat = FULLTILT.Quaternion.prototype.rotateByAxisAngle(this, [1, 0, 0], angle);
      this.copy(outQuat);

      return this;

    };

    this.rotateY = function (angle) {

      outQuat = FULLTILT.Quaternion.prototype.rotateByAxisAngle(this, [0, 1, 0], angle);
      this.copy(outQuat);

      return this;

    };

    this.rotateZ = function (angle) {

      outQuat = FULLTILT.Quaternion.prototype.rotateByAxisAngle(this, [0, 0, 1], angle);
      this.copy(outQuat);

      return this;

    };

    this.normalize = function () {

      return FULLTILT.Quaternion.prototype.normalize(this);

    };

    // Initialize object values
    this.set(x, y, z, w);

  };

  FULLTILT.Quaternion.prototype = {

    constructor: FULLTILT.Quaternion,

    multiplyQuaternions: function () {

      var multipliedQuat = new FULLTILT.Quaternion();

      return function (a, b) {

        var qax = a.x, qay = a.y, qaz = a.z, qaw = a.w;
        var qbx = b.x, qby = b.y, qbz = b.z, qbw = b.w;

        multipliedQuat.set(
          qax * qbw + qaw * qbx + qay * qbz - qaz * qby, // x
          qay * qbw + qaw * qby + qaz * qbx - qax * qbz, // y
          qaz * qbw + qaw * qbz + qax * qby - qay * qbx, // z
          qaw * qbw - qax * qbx - qay * qby - qaz * qbz  // w
        );

        return multipliedQuat;

      };

    }(),

    normalize: function (q) {

      var len = Math.sqrt(q.x * q.x + q.y * q.y + q.z * q.z + q.w * q.w);

      if (len === 0) {

        q.x = 0;
        q.y = 0;
        q.z = 0;
        q.w = 1;

      } else {

        len = 1 / len;

        q.x *= len;
        q.y *= len;
        q.z *= len;
        q.w *= len;

      }

      return q;

    },

    rotateByAxisAngle: function () {

      var outputQuaternion = new FULLTILT.Quaternion();
      var transformQuaternion = new FULLTILT.Quaternion();

      var halfAngle, sA;

      return function (targetQuaternion, axis, angle) {

        halfAngle = (angle || 0) / 2;
        sA = Math.sin(halfAngle);

        transformQuaternion.set(
          (axis[0] || 0) * sA, // x
          (axis[1] || 0) * sA, // y
          (axis[2] || 0) * sA, // z
          Math.cos(halfAngle)    // w
        );

        // Multiply quaternion by q
        outputQuaternion = FULLTILT.Quaternion.prototype.multiplyQuaternions(targetQuaternion, transformQuaternion);

        return FULLTILT.Quaternion.prototype.normalize(outputQuaternion);

      };

    }()

  };

  ////// FULLTILT.RotationMatrix //////

  FULLTILT.RotationMatrix = function (m11, m12, m13, m21, m22, m23, m31, m32, m33) {

    var outMatrix;

    this.elements = new Float32Array(9);

    this.identity = function () {

      this.set(
        1, 0, 0,
        0, 1, 0,
        0, 0, 1
      );

      return this;

    };

    this.set = function (m11, m12, m13, m21, m22, m23, m31, m32, m33) {

      this.elements[0] = m11 || 1;
      this.elements[1] = m12 || 0;
      this.elements[2] = m13 || 0;
      this.elements[3] = m21 || 0;
      this.elements[4] = m22 || 1;
      this.elements[5] = m23 || 0;
      this.elements[6] = m31 || 0;
      this.elements[7] = m32 || 0;
      this.elements[8] = m33 || 1;

    };

    this.copy = function (matrix) {

      this.elements[0] = matrix.elements[0];
      this.elements[1] = matrix.elements[1];
      this.elements[2] = matrix.elements[2];
      this.elements[3] = matrix.elements[3];
      this.elements[4] = matrix.elements[4];
      this.elements[5] = matrix.elements[5];
      this.elements[6] = matrix.elements[6];
      this.elements[7] = matrix.elements[7];
      this.elements[8] = matrix.elements[8];

    };

    this.setFromEuler = (function () {

      var _x, _y, _z;
      var cX, cY, cZ, sX, sY, sZ;

      return function (euler) {

        euler = euler || {};

        _z = (euler.alpha || 0) * degToRad;
        _x = (euler.beta || 0) * degToRad;
        _y = (euler.gamma || 0) * degToRad;

        cX = Math.cos(_x);
        cY = Math.cos(_y);
        cZ = Math.cos(_z);
        sX = Math.sin(_x);
        sY = Math.sin(_y);
        sZ = Math.sin(_z);

        //
        // ZXY-ordered rotation matrix construction.
        //

        this.set(
          cZ * cY - sZ * sX * sY, // 1,1
          - cX * sZ,              // 1,2
          cY * sZ * sX + cZ * sY, // 1,3

          cY * sZ + cZ * sX * sY, // 2,1
          cZ * cX,                // 2,2
          sZ * sY - cZ * cY * sX, // 2,3

          - cX * sY,              // 3,1
          sX,                     // 3,2
          cX * cY                 // 3,3
        );

        this.normalize();

        return this;

      };

    })();

    this.setFromQuaternion = (function () {

      var sqw, sqx, sqy, sqz;

      return function (q) {

        sqw = q.w * q.w;
        sqx = q.x * q.x;
        sqy = q.y * q.y;
        sqz = q.z * q.z;

        this.set(
          sqw + sqx - sqy - sqz,       // 1,1
          2 * (q.x * q.y - q.w * q.z), // 1,2
          2 * (q.x * q.z + q.w * q.y), // 1,3

          2 * (q.x * q.y + q.w * q.z), // 2,1
          sqw - sqx + sqy - sqz,       // 2,2
          2 * (q.y * q.z - q.w * q.x), // 2,3

          2 * (q.x * q.z - q.w * q.y), // 3,1
          2 * (q.y * q.z + q.w * q.x), // 3,2
          sqw - sqx - sqy + sqz        // 3,3
        );

        return this;

      };

    })();

    this.multiply = function (m) {

      outMatrix = FULLTILT.RotationMatrix.prototype.multiplyMatrices(this, m);
      this.copy(outMatrix);

      return this;

    };

    this.rotateX = function (angle) {

      outMatrix = FULLTILT.RotationMatrix.prototype.rotateByAxisAngle(this, [1, 0, 0], angle);
      this.copy(outMatrix);

      return this;

    };

    this.rotateY = function (angle) {

      outMatrix = FULLTILT.RotationMatrix.prototype.rotateByAxisAngle(this, [0, 1, 0], angle);
      this.copy(outMatrix);

      return this;

    };

    this.rotateZ = function (angle) {

      outMatrix = FULLTILT.RotationMatrix.prototype.rotateByAxisAngle(this, [0, 0, 1], angle);
      this.copy(outMatrix);

      return this;

    };

    this.normalize = function () {

      return FULLTILT.RotationMatrix.prototype.normalize(this);

    };

    // Initialize object values
    this.set(m11, m12, m13, m21, m22, m23, m31, m32, m33);

  };

  FULLTILT.RotationMatrix.prototype = {

    constructor: FULLTILT.RotationMatrix,

    multiplyMatrices: function () {

      var matrix = new FULLTILT.RotationMatrix();

      var aE, bE;

      return function (a, b) {

        aE = a.elements;
        bE = b.elements;

        matrix.set(
          aE[0] * bE[0] + aE[1] * bE[3] + aE[2] * bE[6],
          aE[0] * bE[1] + aE[1] * bE[4] + aE[2] * bE[7],
          aE[0] * bE[2] + aE[1] * bE[5] + aE[2] * bE[8],

          aE[3] * bE[0] + aE[4] * bE[3] + aE[5] * bE[6],
          aE[3] * bE[1] + aE[4] * bE[4] + aE[5] * bE[7],
          aE[3] * bE[2] + aE[4] * bE[5] + aE[5] * bE[8],

          aE[6] * bE[0] + aE[7] * bE[3] + aE[8] * bE[6],
          aE[6] * bE[1] + aE[7] * bE[4] + aE[8] * bE[7],
          aE[6] * bE[2] + aE[7] * bE[5] + aE[8] * bE[8]
        );

        return matrix;

      };

    }(),

    normalize: function (matrix) {

      var R = matrix.elements;

      // Calculate matrix determinant
      var determinant = R[0] * R[4] * R[8] - R[0] * R[5] * R[7] - R[1] * R[3] * R[8] + R[1] * R[5] * R[6] + R[2] * R[3] * R[7] - R[2] * R[4] * R[6];

      // Normalize matrix values
      R[0] /= determinant;
      R[1] /= determinant;
      R[2] /= determinant;
      R[3] /= determinant;
      R[4] /= determinant;
      R[5] /= determinant;
      R[6] /= determinant;
      R[7] /= determinant;
      R[8] /= determinant;

      matrix.elements = R;

      return matrix;

    },

    rotateByAxisAngle: function () {

      var outputMatrix = new FULLTILT.RotationMatrix();
      var transformMatrix = new FULLTILT.RotationMatrix();

      var sA, cA;
      var validAxis = false;

      return function (targetRotationMatrix, axis, angle) {

        transformMatrix.identity(); // reset transform matrix

        validAxis = false;

        sA = Math.sin(angle);
        cA = Math.cos(angle);

        if (axis[0] === 1 && axis[1] === 0 && axis[2] === 0) { // x

          validAxis = true;

          transformMatrix.elements[4] = cA;
          transformMatrix.elements[5] = -sA;
          transformMatrix.elements[7] = sA;
          transformMatrix.elements[8] = cA;

        } else if (axis[1] === 1 && axis[0] === 0 && axis[2] === 0) { // y

          validAxis = true;

          transformMatrix.elements[0] = cA;
          transformMatrix.elements[2] = sA;
          transformMatrix.elements[6] = -sA;
          transformMatrix.elements[8] = cA;

        } else if (axis[2] === 1 && axis[0] === 0 && axis[1] === 0) { // z

          validAxis = true;

          transformMatrix.elements[0] = cA;
          transformMatrix.elements[1] = -sA;
          transformMatrix.elements[3] = sA;
          transformMatrix.elements[4] = cA;

        }

        if (validAxis) {

          outputMatrix = FULLTILT.RotationMatrix.prototype.multiplyMatrices(targetRotationMatrix, transformMatrix);

          outputMatrix = FULLTILT.RotationMatrix.prototype.normalize(outputMatrix);

        } else {

          outputMatrix = targetRotationMatrix;

        }

        return outputMatrix;

      };

    }()

  };

  ////// FULLTILT.Euler //////

  FULLTILT.Euler = function (alpha, beta, gamma) {

    this.set = function (alpha, beta, gamma) {

      this.alpha = alpha || 0;
      this.beta = beta || 0;
      this.gamma = gamma || 0;

    };

    this.copy = function (inEuler) {

      this.alpha = inEuler.alpha;
      this.beta = inEuler.beta;
      this.gamma = inEuler.gamma;

    };

    this.setFromRotationMatrix = (function () {

      var R, _alpha, _beta, _gamma;

      return function (matrix) {

        R = matrix.elements;

        if (R[8] > 0) { // cos(beta) > 0

          _alpha = Math.atan2(-R[1], R[4]);
          _beta = Math.asin(R[7]); // beta (-pi/2, pi/2)
          _gamma = Math.atan2(-R[6], R[8]); // gamma (-pi/2, pi/2)

        } else if (R[8] < 0) {  // cos(beta) < 0

          _alpha = Math.atan2(R[1], -R[4]);
          _beta = -Math.asin(R[7]);
          _beta += (_beta >= 0) ? - M_PI : M_PI; // beta [-pi,-pi/2) U (pi/2,pi)
          _gamma = Math.atan2(R[6], -R[8]); // gamma (-pi/2, pi/2)

        } else { // R[8] == 0

          if (R[6] > 0) {  // cos(gamma) == 0, cos(beta) > 0

            _alpha = Math.atan2(-R[1], R[4]);
            _beta = Math.asin(R[7]); // beta [-pi/2, pi/2]
            _gamma = - M_PI_2; // gamma = -pi/2

          } else if (R[6] < 0) { // cos(gamma) == 0, cos(beta) < 0

            _alpha = Math.atan2(R[1], -R[4]);
            _beta = -Math.asin(R[7]);
            _beta += (_beta >= 0) ? - M_PI : M_PI; // beta [-pi,-pi/2) U (pi/2,pi)
            _gamma = - M_PI_2; // gamma = -pi/2

          } else { // R[6] == 0, cos(beta) == 0

            // gimbal lock discontinuity
            _alpha = Math.atan2(R[3], R[0]);
            _beta = (R[7] > 0) ? M_PI_2 : - M_PI_2; // beta = +-pi/2
            _gamma = 0; // gamma = 0

          }

        }

        // alpha is in [-pi, pi], make sure it is in [0, 2*pi).
        if (_alpha < 0) {
          _alpha += M_2_PI; // alpha [0, 2*pi)
        }

        // Convert to degrees
        _alpha *= radToDeg;
        _beta *= radToDeg;
        _gamma *= radToDeg;

        // apply derived euler angles to current object
        this.set(_alpha, _beta, _gamma);

      };

    })();

    this.setFromQuaternion = (function () {

      var _alpha, _beta, _gamma;

      return function (q) {

        var sqw = q.w * q.w;
        var sqx = q.x * q.x;
        var sqy = q.y * q.y;
        var sqz = q.z * q.z;

        var unitLength = sqw + sqx + sqy + sqz; // Normalised == 1, otherwise correction divisor.
        var wxyz = q.w * q.x + q.y * q.z;
        var epsilon = 1e-6; // rounding factor

        if (wxyz > (0.5 - epsilon) * unitLength) {

          _alpha = 2 * Math.atan2(q.y, q.w);
          _beta = M_PI_2;
          _gamma = 0;

        } else if (wxyz < (-0.5 + epsilon) * unitLength) {

          _alpha = -2 * Math.atan2(q.y, q.w);
          _beta = -M_PI_2;
          _gamma = 0;

        } else {

          var aX = sqw - sqx + sqy - sqz;
          var aY = 2 * (q.w * q.z - q.x * q.y);

          var gX = sqw - sqx - sqy + sqz;
          var gY = 2 * (q.w * q.y - q.x * q.z);

          if (gX > 0) {

            _alpha = Math.atan2(aY, aX);
            _beta = Math.asin(2 * wxyz / unitLength);
            _gamma = Math.atan2(gY, gX);

          } else {

            _alpha = Math.atan2(-aY, -aX);
            _beta = -Math.asin(2 * wxyz / unitLength);
            _beta += _beta < 0 ? M_PI : - M_PI;
            _gamma = Math.atan2(-gY, -gX);

          }

        }

        // alpha is in [-pi, pi], make sure it is in [0, 2*pi).
        if (_alpha < 0) {
          _alpha += M_2_PI; // alpha [0, 2*pi)
        }

        // Convert to degrees
        _alpha *= radToDeg;
        _beta *= radToDeg;
        _gamma *= radToDeg;

        // apply derived euler angles to current object
        this.set(_alpha, _beta, _gamma);

      };

    })();

    this.rotateX = function (angle) {

      FULLTILT.Euler.prototype.rotateByAxisAngle(this, [1, 0, 0], angle);

      return this;

    };

    this.rotateY = function (angle) {

      FULLTILT.Euler.prototype.rotateByAxisAngle(this, [0, 1, 0], angle);

      return this;

    };

    this.rotateZ = function (angle) {

      FULLTILT.Euler.prototype.rotateByAxisAngle(this, [0, 0, 1], angle);

      return this;

    };

    // Initialize object values
    this.set(alpha, beta, gamma);

  };

  FULLTILT.Euler.prototype = {

    constructor: FULLTILT.Euler,

    rotateByAxisAngle: function () {

      var _matrix = new FULLTILT.RotationMatrix();
      var outEuler;

      return function (targetEuler, axis, angle) {

        _matrix.setFromEuler(targetEuler);

        _matrix = FULLTILT.RotationMatrix.prototype.rotateByAxisAngle(_matrix, axis, angle);

        targetEuler.setFromRotationMatrix(_matrix);

        return targetEuler;

      };

    }()

  };

  ///// FULLTILT.DeviceOrientation //////

  FULLTILT.DeviceOrientation = function (options) {

    this.options = options || {}; // by default use UA deviceorientation 'type' ("game" on iOS, "world" on Android)

    var tries = 0;
    var maxTries = 2000;
    var successCount = 0;
    var successThreshold = 10;

    this.alphaOffsetScreen = 0;
    this.alphaOffsetDevice = undefined;

    // Create a game-based deviceorientation object (initial alpha === 0 degrees)
    if (this.options.type === "game") {

      var setGameAlphaOffset = function (evt) {

        if (evt.alpha !== null) { // do regardless of whether 'evt.absolute' is also true
          this.alphaOffsetDevice = new FULLTILT.Euler(evt.alpha, 0, 0);
          this.alphaOffsetDevice.rotateZ(-screenOrientationAngle);

          // Discard first {successThreshold} responses while a better compass lock is found by UA
          if (++successCount >= successThreshold) {
            window.removeEventListener('deviceorientation', setGameAlphaOffset, false);
            return;
          }
        }

        if (++tries >= maxTries) {
          window.removeEventListener('deviceorientation', setGameAlphaOffset, false);
        }

      }.bind(this);

      window.addEventListener('deviceorientation', setGameAlphaOffset, false);

      // Create a compass-based deviceorientation object (initial alpha === compass degrees)
    } else if (this.options.type === "world") {

      var setCompassAlphaOffset = function (evt) {
        //alert(evt.alpha)
        if (evt.absolute !== true && evt.webkitCompassAccuracy !== undefined && evt.webkitCompassAccuracy !== null && +evt.webkitCompassAccuracy >= 0 && +evt.webkitCompassAccuracy < 50) {
          this.alphaOffsetDevice = new FULLTILT.Euler(evt.webkitCompassHeading, 0, 0);
          this.alphaOffsetDevice.rotateZ(screenOrientationAngle);
          this.alphaOffsetScreen = screenOrientationAngle;
          // Discard first {successThreshold} responses while a better compass lock is found by UA
          if (++successCount >= successThreshold) {
            window.removeEventListener('deviceorientation', setCompassAlphaOffset, false);
            return;
          }
        }

        if (++tries >= maxTries) {
          window.removeEventListener('deviceorientation', setCompassAlphaOffset, false);
        }

      }.bind(this);

      window.addEventListener('deviceorientation', setCompassAlphaOffset, false);

    } // else... use whatever orientation system the UA provides ("game" on iOS, "world" on Android)

  };

  FULLTILT.DeviceOrientation.prototype = {

    constructor: FULLTILT.DeviceOrientation,

    start: function (callback) {

      if (callback && Object.prototype.toString.call(callback) == '[object Function]') {

        sensors.orientation.callbacks.push(callback);

      }

      if (!screenActive) {

        if (hasScreenOrientationAPI) {

          window.screen.orientation.addEventListener('change', handleScreenOrientationChange, false);

        } else {

          window.addEventListener('orientationchange', handleScreenOrientationChange, false);

        }

      }

      if (!sensors.orientation.active) {

        window.addEventListener('deviceorientation', handleDeviceOrientationChange, false);

        sensors.orientation.active = true;

      }

    },

    stop: function () {

      if (sensors.orientation.active) {

        window.removeEventListener('deviceorientation', handleDeviceOrientationChange, false);

        sensors.orientation.active = false;

      }

    },

    listen: function (callback) {

      this.start(callback);

    },

    getFixedFrameQuaternion: (function () {

      var euler = new FULLTILT.Euler();
      var matrix = new FULLTILT.RotationMatrix();
      var quaternion = new FULLTILT.Quaternion();

      return function () {

        var orientationData = sensors.orientation.data || { alpha: 0, beta: 0, gamma: 0 };

        var adjustedAlpha = orientationData.alpha;

        if (this.alphaOffsetDevice) {
          matrix.setFromEuler(this.alphaOffsetDevice);
          matrix.rotateZ(- this.alphaOffsetScreen);
          euler.setFromRotationMatrix(matrix);

          if (euler.alpha < 0) {
            euler.alpha += 360;
          }

          euler.alpha %= 360;

          adjustedAlpha -= euler.alpha;
        }

        euler.set(
          adjustedAlpha,
          orientationData.beta,
          orientationData.gamma
        );

        quaternion.setFromEuler(euler);

        return quaternion;

      };

    })(),

    getScreenAdjustedQuaternion: (function () {

      var quaternion;

      return function () {

        quaternion = this.getFixedFrameQuaternion();
        //alert(screenOrientationAngle)
        // Automatically apply screen orientation transform
        quaternion.rotateZ(- screenOrientationAngle);

        return quaternion;

      };

    })(),

    getFixedFrameMatrix: (function () {

      var euler = new FULLTILT.Euler();
      var matrix = new FULLTILT.RotationMatrix();

      return function () {

        var orientationData = sensors.orientation.data || { alpha: 0, beta: 0, gamma: 0 };

        var adjustedAlpha = orientationData.alpha;

        if (this.alphaOffsetDevice) {
          matrix.setFromEuler(this.alphaOffsetDevice);
          matrix.rotateZ(- this.alphaOffsetScreen);
          euler.setFromRotationMatrix(matrix);

          if (euler.alpha < 0) {
            euler.alpha += 360;
          }

          euler.alpha %= 360;

          adjustedAlpha -= euler.alpha;
        }

        euler.set(
          adjustedAlpha,
          orientationData.beta,
          orientationData.gamma
        );

        matrix.setFromEuler(euler);

        return matrix;

      };

    })(),

    getScreenAdjustedMatrix: (function () {

      var matrix;

      return function () {

        matrix = this.getFixedFrameMatrix();

        // Automatically apply screen orientation transform
        matrix.rotateZ(- screenOrientationAngle);

        return matrix;

      };

    })(),

    getFixedFrameEuler: (function () {

      var euler = new FULLTILT.Euler();
      var matrix;

      return function () {

        matrix = this.getFixedFrameMatrix();

        euler.setFromRotationMatrix(matrix);

        return euler;

      };

    })(),

    getScreenAdjustedEuler: (function () {

      var euler = new FULLTILT.Euler();
      var matrix;

      return function () {

        matrix = this.getScreenAdjustedMatrix();

        euler.setFromRotationMatrix(matrix);

        return euler;

      };

    })(),

    isAbsolute: function () {

      if (sensors.orientation.data && sensors.orientation.data.absolute === true) {
        return true;
      }

      return false;

    },

    getLastRawEventData: function () {

      return sensors.orientation.data || {};

    },

    ALPHA: 'alpha',
    BETA: 'beta',
    GAMMA: 'gamma'

  };


  ///// FULLTILT.DeviceMotion //////

  FULLTILT.DeviceMotion = function (options) {

    this.options = options || {}; // placeholder object since no options are currently supported

  };

  FULLTILT.DeviceMotion.prototype = {

    constructor: FULLTILT.DeviceMotion,

    start: function (callback) {

      if (callback && Object.prototype.toString.call(callback) == '[object Function]') {

        sensors.motion.callbacks.push(callback);

      }

      if (!screenActive) {

        if (hasScreenOrientationAPI) {

          window.screen.orientation.addEventListener('change', handleScreenOrientationChange, false);

        } else {

          window.addEventListener('orientationchange', handleScreenOrientationChange, false);

        }

      }

      if (!sensors.motion.active) {

        window.addEventListener('devicemotion', handleDeviceMotionChange, false);

        sensors.motion.active = true;

      }

    },

    stop: function () {

      if (sensors.motion.active) {

        window.removeEventListener('devicemotion', handleDeviceMotionChange, false);

        sensors.motion.active = false;

      }

    },

    listen: function (callback) {

      this.start(callback);

    },

    getScreenAdjustedAcceleration: function () {

      var accData = sensors.motion.data && sensors.motion.data.acceleration ? sensors.motion.data.acceleration : { x: 0, y: 0, z: 0 };
      var screenAccData = {};

      switch (screenOrientationAngle) {
        case SCREEN_ROTATION_90:
          screenAccData.x = - accData.y;
          screenAccData.y = accData.x;
          break;
        case SCREEN_ROTATION_180:
          screenAccData.x = - accData.x;
          screenAccData.y = - accData.y;
          break;
        case SCREEN_ROTATION_270:
        case SCREEN_ROTATION_MINUS_90:
          screenAccData.x = accData.y;
          screenAccData.y = - accData.x;
          break;
        default: // SCREEN_ROTATION_0
          screenAccData.x = accData.x;
          screenAccData.y = accData.y;
          break;
      }

      screenAccData.z = accData.z;

      return screenAccData;

    },

    getScreenAdjustedAccelerationIncludingGravity: function () {

      var accGData = sensors.motion.data && sensors.motion.data.accelerationIncludingGravity ? sensors.motion.data.accelerationIncludingGravity : { x: 0, y: 0, z: 0 };
      var screenAccGData = {};

      switch (screenOrientationAngle) {
        case SCREEN_ROTATION_90:
          screenAccGData.x = - accGData.y;
          screenAccGData.y = accGData.x;
          break;
        case SCREEN_ROTATION_180:
          screenAccGData.x = - accGData.x;
          screenAccGData.y = - accGData.y;
          break;
        case SCREEN_ROTATION_270:
        case SCREEN_ROTATION_MINUS_90:
          screenAccGData.x = accGData.y;
          screenAccGData.y = - accGData.x;
          break;
        default: // SCREEN_ROTATION_0
          screenAccGData.x = accGData.x;
          screenAccGData.y = accGData.y;
          break;
      }

      screenAccGData.z = accGData.z;

      return screenAccGData;

    },

    getScreenAdjustedRotationRate: function () {

      var rotRateData = sensors.motion.data && sensors.motion.data.rotationRate ? sensors.motion.data.rotationRate : { alpha: 0, beta: 0, gamma: 0 };
      var screenRotRateData = {};

      switch (screenOrientationAngle) {
        case SCREEN_ROTATION_90:
          screenRotRateData.beta = - rotRateData.gamma;
          screenRotRateData.gamma = rotRateData.beta;
          break;
        case SCREEN_ROTATION_180:
          screenRotRateData.beta = - rotRateData.beta;
          screenRotRateData.gamma = - rotRateData.gamma;
          break;
        case SCREEN_ROTATION_270:
        case SCREEN_ROTATION_MINUS_90:
          screenRotRateData.beta = rotRateData.gamma;
          screenRotRateData.gamma = - rotRateData.beta;
          break;
        default: // SCREEN_ROTATION_0
          screenRotRateData.beta = rotRateData.beta;
          screenRotRateData.gamma = rotRateData.gamma;
          break;
      }

      screenRotRateData.alpha = rotRateData.alpha;

      return screenRotRateData;

    },

    getLastRawEventData: function () {

      return sensors.motion.data || {};

    }

  };


  ////// Attach FULLTILT to root DOM element //////

  window.FULLTILT = FULLTILT;

})(window);

function VRGyro(type) {
  var self = this;
  self.type = type
  self.orientationPromise = undefined
  self.el = [];
  var M_PI = Math.PI;
  var M_PI_2 = M_PI / 2;
  var M_2_PI = 2 * M_PI;

  // Degree to Radian conversion
  var degToRad = M_PI / 180;
  var radToDeg = 180 / M_PI;
  var hasScreenOrientationAPI = window.screen && window.screen.orientation && window.screen.orientation.angle !== undefined && window.screen.orientation.angle !== null ? true : false;
  var screenOrientationAngle = (hasScreenOrientationAPI ? window.screen.orientation.angle : (window.orientation || 0)) * degToRad;
  var deviceHeading = null;
  this.addEventListener = function (type, listener) {
    var self = this;
    if (self._listeners === undefined) self._listeners = {};

    var listeners = self._listeners;

    if (listeners[type] === undefined) {

      listeners[type] = [];

    }

    if (listeners[type].indexOf(listener) === - 1) {

      listeners[type].push(listener);

    }

  }

  this.hasEventListener = function (type, listener) {
    var self = this;
    if (self._listeners === undefined) return false;

    var listeners = self._listeners;

    return listeners[type] !== undefined && listeners[type].indexOf(listener) !== - 1;

  }

  this.removeEventListener = function (type, listener) {
    var self = this;
    if (self._listeners === undefined) return;

    var listeners = self._listeners;
    var listenerArray = listeners[type];

    if (listenerArray !== undefined) {

      var index = listenerArray.indexOf(listener);

      if (index !== - 1) {

        listenerArray.splice(index, 1);

      }

    }

  }

  this.dispatchEvent = function (type, data) {
    var self = this;
    if (self._listeners === undefined) return;

    var listeners = self._listeners;
    var listenerArray = listeners[type];

    if (listenerArray !== undefined) {

      //event.target = this;

      var array = listenerArray.slice(0);

      for (var i = 0, l = array.length; i < l; i++) {

        array[i].call(self, data);

      }

    }

  }
  self.quaternion = [];
  function handleDeviceOrientation(event) {
    if ((!event["alpha"]) || (!event["beta"]) || (!event["gamma"])) return;

    if ((event.webkitCompassHeading) && ((!event.webkitCompassAccuracy) || (event.webkitCompassAccuracy >= 0))) { // iOS
      deviceHeading = event.webkitCompassHeading;
      if (window.orientation) {
        deviceHeading += window.orientation;
      }
    } else deviceHeading = event.alpha;
  }
  function draw() {
    if (!self.activated) {
      return
    }
    if (!self.controls) {
    }

    // Use the currently selected rotation representation to set our camera position
    // (But always convert results to an intermediate quartenion so we can then apply our world transform)
    if (self.controls && self.controls.getScreenAdjustedQuaternion) {

      var quaternion = self.controls.getScreenAdjustedQuaternion();
      var orientationData = self.controls.getLastRawEventData() || { alpha: 0, beta: 0, gamma: 0 };

      self.quaternion = [quaternion.x, quaternion.y, quaternion.z, quaternion.w];
      var e = {
        target: {
          quaternion: self.quaternion,
          type: type,
          orientationData
        }
      }
      self.dispatchEvent('reading', e);
    }
    else {
    }

    // IMPORTANT! set deviceorientation camera to three.js world frame
    // (i.e. make camera look out the back of the screen by rotating the camera x-axis by -PI/2)
    //camera.quaternion.multiplyQuaternions(world_transform, threejs_quaternion);

    // Render scene
    //renderer.render(scene, camera);

    // Re-draw at next browser animation frame
    requestAnimationFrame(draw);

  }
  self.handleScreenOrientationChange = function () {

    if (hasScreenOrientationAPI) {

      self.controls.screenOrientationAngle = (window.screen.orientation.angle || 0) * degToRad;

    } else {

      self.controls.screenOrientationAngle = (window.orientation || 0) * degToRad;

    }

  }
  const isIOSCheck = /iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  function onOrientationChange(deviceOrientationController) {

    self.controls = deviceOrientationController;
    if (isFirefox || (isIOS || isIOSCheck)) {
      window.addEventListener("resize", self.handleScreenOrientationChange, false);
    }
    draw(); // start
  }
  self.onDeviceMotionDialogAllowClicked = async function () {

    var orientationPromise = new window.FULLTILT.getDeviceOrientation({ type: type });
    orientationPromise.then(function (controller) {
      // Store the returned FULLTILT.DeviceOrientation object
      onOrientationChange(controller);
    })
      .catch(async function (message) {
        console.error(message);
        alert(message)
        await self.onDeviceMotionDialogAllowClicked()
        // Optionally set up fallback controls...
        // initManualControls();
      });
    // onOrientationChange(orientationPromise)

  }

  self.start = async function () {
    var self = this;
    self.permissionGranted = true;

    // Request permission for iOS 13+ devices
    if (
      DeviceMotionEvent &&
      typeof DeviceOrientationEvent.requestPermission === "function"
    ) {
      try {
        // Request permission
        const permissionStatus = await DeviceOrientationEvent.requestPermission();
        // Check if permission was granted
        if (permissionStatus === 'granted') {
          // Permission granted, you can now listen to device orientation events
          if (!self.activated) {
            self.activated = true;
            await self.onDeviceMotionDialogAllowClicked();
          }
        } else {
          // Permission denied
          console.error('Device orientation permission denied.');
        }
      } catch (error) {
        alert(error)
        // Handle errors, e.g., if the browser doesn't support the feature
        console.error('Error requesting device orientation permission:', error);
      }
      DeviceMotionEvent.requestPermission();
    }
    else {
      if (!self.activated) {
        self.activated = true;
        await self.onDeviceMotionDialogAllowClicked();
      }
    }
    // if (window.hasOwnProperty("DeviceOrientationEvent")) { // fix for iOS 13
    //   if (DeviceOrientationEvent.hasOwnProperty("requestPermission")) {
    //     if (typeof DeviceMotionEvent.requestPermission === 'function') {

    //       DeviceOrientationEvent.requestPermission()
    //         .then(function (response) {
    //           self.permissionGranted = true;
    //           if (response === 'granted') {
    //             self.activated = true;
    //             self.onDeviceMotionDialogAllowClicked();

    //           } else {

    //           }
    //         });

    //     }
    //   }
    //   else {
    //     self.permissionGranted = true;
    //     self.activated = true;
    //     self.onDeviceMotionDialogAllowClicked();
    //   }
    // }
    return self.activated;
  }

  self.stop = function () {
    if (isDeviceEnabled && self.activated) {
      if (('ondeviceorientationabsolute' in window) && (isTrueNorth)) {
        window.removeEventListener("deviceorientationabsolute", handleDeviceOrientation);
        window.removeEventListener("deviceorientation", handleDeviceOrientation);
      } else if ('ondeviceorientation' in window) {
        window.removeEventListener("deviceorientation", handleDeviceOrientation);
        window.removeEventListener("deviceorientationabsolute", handleDeviceOrientation);
      }
      window.removeEventListener("resize", self.handleScreenOrientationChange);
      self.activated = false;
    }
    if (self.controls) {

      self.controls.stop()
    }
    return self.activated;
  }

  var isDeviceEnabled = !!window.DeviceOrientationEvent;
  self.activated = false;

  var isTrueNorth = false;

  ////////////////////////////////////////////////////////////
}

const Gps = props => {
  const {
    projectStore,
    commonStore,
    capturesStore,
    viewer,
    webcamRef,
    projectid,
    usersStore
  } = props
  const { t } = useTranslation();
  const [freezeCamera, setFreezeCamera] = useState(false)
  const [timestamp, settimestamp] = useState(false)
  const [handlerViewer, setHandleViewer] = useState(null)
  function getViewer() {
    if (!viewer.current) return false
    if (!viewer.current.cesiumElement) return false
    return viewer.current.cesiumElement;
  }
  const [markerPos, setMarkerPos] = useState(null)
  const [visiblePermission, setvisiblePermission] = useState(false)
  const [cesiumCanvasSizeFlowCamera, setCesiumCanvasSizeFlowCamera] = useState(0)
  const pinBuilder = new PinBuilder()
  const greenPin = {
    image: pinBuilder.fromColor(Color.GREEN, 32).toDataURL(),
    verticalOrigin: VerticalOrigin.BOTTOM,
  }
  useEffect(() => {
    if (viewer.current && viewer.current.cesiumElement) {
      if (commonStore.manualGpsState === 1) {
        commonStore.setGPSUpdate(false)
        try {
          const longitude = typeof projectStore.currentGPS.coords.longitude === 'string' ? parseFloat(projectStore.currentGPS.coords.longitude) : projectStore.currentGPS.coords.longitude;
          const latitude = typeof projectStore.currentGPS.coords.latitude === 'string' ? parseFloat(projectStore.currentGPS.coords.latitude) : projectStore.currentGPS.coords.latitude;

          const obtGPSHeight = (projectStore.obtGPSHeight && projectStore.obtGPSHeight.height ? projectStore.obtGPSHeight.height : projectStore.currentGPS?.coords?.altitude) || 0;

          var pos = Cartesian3.fromDegrees(
            longitude, latitude, obtGPSHeight
          )
          setMarkerPos(
            pos
          )
          const pitch = CesiumMath.toRadians(-89.99)
          const offset = new HeadingPitchRange(getViewer().scene.camera.heading, pitch, 55);
          getViewer().flyTo(pinRef.current.cesiumElement, {
            offset: offset,
            duration: 0
          }).then(() => {
            projectStore.set2D(true)
          })
        } catch (error) {

        }
      }
    }
  }, [viewer]);
  // Firefox 1.0+
  const isFirefox = typeof InstallTrigger !== 'undefined';

  const pinRef = useRef(null)
  const handlePermissionOk = async e => {
    try {
      // Request permission
      const permissionStatus = await DeviceOrientationEvent.requestPermission();

      // Check if permission was granted
      if (permissionStatus === 'granted') {
        var iosAGyro = new VRGyro("world");
        iosAGyro.addEventListener("reading", function (e) { onReadingSensorMotion(e, 'absolute') });
        projectStore.setobtAbsoluteDeviceSensor(iosAGyro);

        var iosRGyro = new VRGyro("game");
        iosRGyro.addEventListener("reading", function (e) { onReadingSensorMotion(e, 'relative') });
        projectStore.setobtRelativeDeviceSensor(iosRGyro);

        setvisiblePermission(false)
        if (projectStore.gpsMode === 'fix' || projectStore.gpsMode === 'first_person') {
          getOrientation()
        }
      } else {
        alert('Device orientation permission denied.')
        // Permission denied
        console.error('Device orientation permission denied.');
      }
    } catch (error) {
      alert('Error requesting device orientation permission')
      // Handle errors, e.g., if the browser doesn't support the feature
      console.error('Error requesting device orientation permission:', error);
    }

  };

  const handlePermissionCancel = e => {
    setvisiblePermission(false)
  };
  function stopAllSensor() {
    try {
      if (projectStore.obtAbsoluteDeviceSensor) {

        projectStore.obtAbsoluteDeviceSensor.stop()
      }
      if (projectStore.obtRelativeDeviceSensor) {
        projectStore.obtRelativeDeviceSensor.stop()
      }
    } catch (error) {
      console.log(error)
    }

  }
  function getCurrentOrientationSensor() {

    return commonStore.useAbsoluteOrientation ? projectStore.obtAbsoluteDeviceSensor : projectStore.obtRelativeDeviceSensor
  }
  // function getSensor(useAbsoluteOrientation) {
  //   if (useAbsoluteOrientation) { return projectStore.obtAbsoluteDeviceSensor }
  //   else { return projectStore.obtRelativeDeviceSensor }
  // }
  async function getOrientation() {
    const sensor = getCurrentOrientationSensor()
    if (sensor && sensor.start && !sensor.activated) {
      await sensor.start()
    }
    if (!sensor) {
    }
  }
  function radians_to_degrees(radians) {
    var pi = Math.PI;
    return radians * (180 / pi);
  }
  function degreesToRadians(degrees) {
    var radians = degrees % 360;
    return radians * Math.PI / 180;
  }
  function getHeadingPitchRoll(option, excludeCorrection, isChangeCompassType) {

    let s = '0'
    if (isChangeCompassType) {
      s = 1
    }
    const _sensor = option?.sensor
    const isAbsolute = option?.isAbsolute
    const sensor = _sensor || getCurrentOrientationSensor(s)
    var deltaRadians = CesiumMath.toRadians(1.0);
    var correctValue = projectStore.openCVData;
    var verticalCorrection = correctValue.vc;
    var horizonCorrection = correctValue.hc;
    var b = sensor.quaternion;
    var type = sensor.type
    if (b && b.length) {
      //if (!q)
      var q = new Quaternion(b[0], b[1], b[2], b[3]);

      var hpr = HeadingPitchRoll.fromQuaternion(q);
      if (isAbsolute) {
        hpr.heading += CesiumMath.PI
      }

      if (excludeCorrection) {
        return hpr
      }
      if (!isNaN(verticalCorrection)) {
        hpr.roll += (deltaRadians * verticalCorrection) / 2;
        // if (hpr.roll < -CesiumMath.TWO_PI) {
        //   hpr.roll += CesiumMath.TWO_PI;
        // }
      }
      if (!isNaN(horizonCorrection)) {
        hpr.heading += deltaRadians * horizonCorrection;
        // if (hpr.heading < -CesiumMath.TWO_PI) {
        //   hpr.heading += CesiumMath.TWO_PI;
        // }
      }
      //console.log('hpr', hpr)
      if (projectStore.absoluteHPRData && projectStore.absoluteHPRData.length) {
        if (false) {
          hpr.heading = projectStore.absoluteHPRData.heading
        }
        else {
          //console.log('absoluteHPRData', projectStore.absoluteHPRData)
          // if (projectStore.absoluteHPRData.roll)
          //   hpr.roll += projectStore.absoluteHPRData.roll
          //let alphaToSend = hpr.heading
          let alphaToSend = projectStore.absoluteHPRData[projectStore.absoluteHPRData.length - 1].heading - projectStore.absoluteHPRData[0].heading

          if (alphaToSend) {
            //alphaToSend = alphaToSend - projectStore.absoluteHPRData.heading;
            // console.log(projectStore.absoluteHPRData.heading + hpr.heading)absoluteHPRData
            //hpr.heading = projectStore.absoluteHPRData.heading + hpr.heading
            hpr.heading = hpr.heading - alphaToSend
            // if (hpr.heading < -CesiumMath.TWO_PI) {
            //   hpr.heading += CesiumMath.TWO_PI;
            // }
          }
          // if (projectStore.absoluteHPRData.pitch){

          //   hpr.pitch = projectStore.absoluteHPRData.pitch + hpr.pitch 
          // }

          // if (projectStore.absoluteHPRData.roll){

          //   hpr.roll = projectStore.absoluteHPRData.roll + hpr.roll
          // }
        }


      }
      // if (hpr.heading < -CesiumMath.TWO_PI) {
      //   hpr.heading += CesiumMath.TWO_PI;
      // }
      // if (hpr.roll < -CesiumMath.TWO_PI) {
      //   hpr.roll += CesiumMath.TWO_PI;
      // }
      // if (hpr.pitch < -CesiumMath.TWO_PI) {
      //   hpr.pitch += CesiumMath.TWO_PI;
      // }
      // if (correctValue && correctValue.angle && correctValue.angle < 999 && correctValue.apply) {
      //   hpr.heading -= degreesToRadians(correctValue.angle)
      // }
      return hpr
    }

  }

  //R.1: Converting window.obtDeviceOrientation angles to a Rotation Matrix representation

  //R.2: Fixing our rotation matrix frame relative to the current screen orientation

  //R.3: Fix our rotation matrix frame relative to our application’s world orientation (rotation around x-axis)

  //R.4: Computing our final rotation matrix representation

  //Returns a 3 x 3 rotation matrix as an array



  function updateGPSPosition(position) {

    if (freezeCamera) return
    if (commonStore.manualGpsState === 1) return
    if (projectStore.gpsMode === 'fix' || projectStore.gpsMode === 'first_person') {
      createMotionTracking()
    }

    var firstGPSTime = true;
    var firstCompassTime = false;
    var colonePosition = {
      coords: {
        accuracy: position.coords.accuracy,
        altitude: position.coords.altitude,
        altitudeAccuracy: position.coords.altitudeAccuracy,
        heading: position.coords.heading,
        latitude: parseFloat(position.coords.latitude),
        longitude: parseFloat(position.coords.longitude),
        speed: position.coords.speed,
      },
      timestamp: position.timestamp
    }

    if (projectStore.currentGPS.coords) {
      firstGPSTime = false
    }
    let distance = 0;
    if (!position || !commonStore.GPSUpdate) {
      position = projectStore.currentGPS
    }
    else {
      if (!projectStore.currentGPS.coords) {
        projectStore.setCurrentGPS(colonePosition)
      } else {
        let height = projectStore.obtGPSHeight ? projectStore.obtGPSHeight.height : 0;
        let prvLat = projectStore.obtGPSHeight && !isNaN(projectStore.obtGPSHeight.lat) ? projectStore.obtGPSHeight.lat : colonePosition.coords.latitude;
        let prvLon = projectStore.obtGPSHeight && !isNaN(projectStore.obtGPSHeight.lon) ? projectStore.obtGPSHeight.lon : colonePosition.coords.longitude;
        let f = Cartographic.toCartesian(Cartographic.fromDegrees(prvLon, prvLat, height), Ellipsoid.WGS84, new Cartesian3());
        //let distance = Cartesian3.distance(getViewer().camera._positionWC, f);
        distance = projectStore.calculateGPSDistance({ lon: prvLon, lat: prvLat }, { lon: colonePosition.coords.longitude, lat: colonePosition.coords.latitude })

        if (distance === 0) {
          projectStore.setLoadingProgress(false)
        }
        if (firstGPSTime || distance > 1.52) { // if distance >2.1m then will update current GPS
          projectStore.setCurrentGPS(colonePosition)
        }
      }
    }

    const longitude = typeof projectStore.currentGPS?.coords?.longitude === 'string' ? parseFloat(projectStore.currentGPS.coords.longitude) : projectStore.currentGPS?.coords?.longitude;
    const latitude = typeof projectStore.currentGPS?.coords?.latitude === 'string' ? parseFloat(projectStore.currentGPS.coords.latitude) : projectStore.currentGPS?.coords?.latitude;
    if (!longitude || !latitude) return
    // var currentCameraLookAt = cameraLookingAt();
    const obtGPSHeight = (projectStore.obtGPSHeight && projectStore.obtGPSHeight.height ? projectStore.obtGPSHeight.height : projectStore.currentGPS?.coords?.altitude) || 0;
    var clamp = false
    var pos = Cartesian3.fromDegrees(
      longitude, latitude, obtGPSHeight
    )

    if (!commonStore.GPSUpdate) {

      setMarkerPos(
        pos
      )
    }
    else {
      commonStore.setCameraPossition({ reset: true })
      const onSampleTerrainSuccess = function (f) {
        projectStore.setLoadingProgress(false)
        if (!getViewer()) return
        if (f) { clamp = true }
        else {
          f = pos
        }

        var g = Cartographic.fromCartesian(f || pos, Ellipsoid.WGS84, new Cartographic())
        const obtGPSHeight = (projectStore.obtGPSHeight && projectStore.obtGPSHeight.height ? projectStore.obtGPSHeight.height : projectStore.currentGPS?.coords?.altitude) || 0;
        if (firstGPSTime || distance > 1.52 || (g.height - obtGPSHeight > 20)) { // if distance >2.1m then will update current GPS
          //projectStore.setCurrentGPS(colonePosition)

          projectStore.setObtGPSElevation(g.height, latitude, longitude, f);
        }

        if (getViewer().camera) {
          setMarkerPos(
            f || pos
          )
          if (projectStore.gpsMode === 'fix') {

          } else if (projectStore.gpsMode === 'first_person') {

          } else {
            if (!projectStore.enableReCenterGPS && projectStore.gpsMode !== 'fix') {
              const pitch = CesiumMath.toRadians(-45.0)
              if (projectStore.projectDetail.defaultStartupMode === 'gps_compass') {
                projectStore.setGpsMode('fix')
              }
              const offset = new HeadingPitchRange(getViewer().scene.camera.heading, pitch, 50);
              getViewer().flyTo(pinRef.current.cesiumElement, {
                offset: offset,
                duration: 0
              }).then(() => {
                getViewer().trackedEntity = pinRef.current.cesiumElement
                projectStore.setEnableReCenterGPS(true);
                commonStore.setCameraPossition(new Cartesian3(getViewer().camera._positionWC.x, getViewer().camera._positionWC.y, getViewer().camera._positionWC.z));
                commonStore.setCameraHeadingPitchRoll({
                  heading: getViewer().camera.heading,
                  pitch: getViewer().camera.pitch,
                  roll: getViewer().camera.roll,
                  timestamp: new Date().getTime()
                })
              })
            } else {
              if (projectStore.gpsMode !== 'fix') {
                getViewer().trackedEntity = pinRef.current.cesiumElement

                commonStore.setCameraHeadingPitchRoll({
                  heading: getViewer().camera.heading,
                  pitch: getViewer().camera.pitch,
                  roll: getViewer().camera.roll,
                  timestamp: new Date().getTime()
                })
                commonStore.setCameraPossition(
                  new Cartesian3(
                    getViewer().camera._positionWC.x,
                    getViewer().camera._positionWC.y,
                    getViewer().camera._positionWC.z)
                );
              }
            }
            if(projectStore.gpsMode === 'none'){
              var centerScreen = getCenterScreenCoordinates(getViewer())
              if (!centerScreen || !getViewer().camera) return
              var transform = Transforms.eastNorthUpToFixedFrame(centerScreen.oldPos)
              var saveCamData = {
                heading: getViewer().camera.heading,
                pitch: getViewer().camera.pitch,
                roll: getViewer().camera.roll,
              }
              
              projectStore.setObtGPSOrientation({});
              getViewer().camera.lookAtTransform(
                transform,
                new HeadingPitchRange(
                  // projectStore.obtGPSOrientation.orientation.heading,
                  saveCamData.heading,
                  saveCamData.pitch,
                  centerScreen.dis
                )
              )
              getViewer().scene.screenSpaceCameraController.enableTilt = true
              getViewer().scene.screenSpaceCameraController.enableInputs = true
              getViewer().camera.lookAtTransform(Matrix4.IDENTITY)
            }
          }
        }
      }
      //var f = getViewer().scene.clampToHeight(Cartesian3.fromDegrees(position.coords.longitude, position.coords.latitude, position.coords.altitude || 0), [], 0.1, new Cartesian3())
      obtSampleTerrain(latitude, longitude, firstGPSTime).then(onSampleTerrainSuccess)
    }
  }
  const explitiFromSample = () => {
    //var fistModel = projectStore.modelList && projectStore.modelList.length>0?projectStore.modelList[0]: undefined;
    var modelList = []
    var primitives = getViewer().scene.primitives;
    for (var i = 0; i < primitives.length; i++) {
      var _tileset = primitives.get(i)
      var model = projectStore.findModelByUrl(_tileset?.resource?.url)
      //if(model && fistModel.id !== model.id) {
      if (model && !model.isRender) {
        modelList.push(_tileset)
      }
    }
    return modelList;
  }
  useEffect(() => {
    if (commonStore.manualGpsState === 1) {
      if (getViewer()) {
        const hanlder = new ScreenSpaceEventHandler(getViewer().canvas)
        hanlder.setInputAction(function (event) {
          try {
            let resultClick = clickPoint(getViewer(), event.position)
            if (resultClick) {
              var g = Cartographic.fromCartesian(resultClick.position, Ellipsoid.WGS84, new Cartographic())

              var colonePosition = {
                coords: {
                  // accuracy: position.coords.accuracy,
                  altitude: g.height,
                  // altitudeAccuracy: position.coords.altitudeAccuracy,
                  // heading: position.coords.heading,
                  latitude: radians_to_degrees(g.latitude),
                  longitude: radians_to_degrees(g.longitude),
                  // speed: position.coords.speed,
                },
                timestamp: (new Date()).getTime()
              }
              projectStore.setCurrentGPS(colonePosition)
              projectStore.setObtGPSElevation(g.height, g.latitude, g.longitude, resultClick.position);
              setMarkerPos(resultClick.position)
              if (getViewer().scene.requestRenderMode) { getViewer().scene.requestRender(); }
            }
          } catch (error) { }
        }, ScreenSpaceEventType.LEFT_CLICK)
        setHandleViewer(hanlder)
      }
    }
    else {
      if (handlerViewer && handlerViewer.removeInputAction) {
        handlerViewer.removeInputAction(ScreenSpaceEventType.LEFT_CLICK)
        setHandleViewer(null)
      }
    }
  }, [commonStore.manualGpsState])
  useEffect(() => {
    if (cesiumCanvasSizeFlowCamera > 0 && webcamRef.current && webcamRef.current.video) {
      //(cesiumCanvasSizeFlowCamera)
      if (webcamRef.current.video.clientHeight > webcamRef.current.video.clientWidth) {
        if (getViewer().canvas) {
          getViewer().canvas.style.height = "100%"
          getViewer().canvas.style.width = cesiumCanvasSizeFlowCamera + "px"
        }
      } else {
        if (getViewer().canvas) {
          getViewer().canvas.style.height = cesiumCanvasSizeFlowCamera + "px"
          getViewer().canvas.style.width = "100%"
        }
      }
    }
  }, [cesiumCanvasSizeFlowCamera])

  const obtSampleTerrain = async (lat, lon, tried) => {
    // check get camera size to set for cesium canvas size
    if (webcamRef.current && webcamRef.current.video && webcamRef.current.video.clientWidth && webcamRef.current.video.clientHeight) {
      if (webcamRef.current.video.clientHeight > webcamRef.current.video.clientWidth) { // portraits 
        if (webcamRef.current.video.clientWidth !== cesiumCanvasSizeFlowCamera) {
          setCesiumCanvasSizeFlowCamera(webcamRef.current.video.clientWidth)
        }
      } else {
        if (webcamRef.current.video.clientHeight !== cesiumCanvasSizeFlowCamera) { // landscape
          setCesiumCanvasSizeFlowCamera(webcamRef.current.video.clientHeight)
        }
      }
    }

    if (!getViewer().scene) return
    if (isNaN(tried)) tried = 0;
    var ls = explitiFromSample();
    if (true) {
      var positions = [
        Cartographic.fromDegrees(lon, lat),
      ];
      if (tried > 2) {
        positions[0].height = projectStore.currentGPS.coords.altitude ? projectStore.currentGPS.coords.altitude : 0
        return Cartographic.toCartesian(positions[0], Ellipsoid.WGS84, new Cartesian3());
      }
      tried++;
      var updatedPositions = await getViewer().scene.sampleHeightMostDetailed(positions, ls, 0.2);

      if (!updatedPositions.length) {
        return await obtSampleTerrain(lat, lon, tried);
      }

      if (!updatedPositions[0] || !updatedPositions[0].height || updatedPositions[0].height < 0) {

        var height = getViewer().scene.sampleHeight(positions[0], [ls], 0.2);
        var prevHeight = (projectStore.obtGPSHeight && projectStore.obtGPSHeight.height ? projectStore.obtGPSHeight.height : projectStore.currentGPS?.coords?.altitude) || 0;

        if (prevHeight && projectStore.calculateGPSDistance({ lon, lat }, projectStore.obtGPSHeight) < 2.5) {
          height = prevHeight;
        }
        if (!height) {
          if (tried < 2) {
            return await obtSampleTerrain(lat, lon, tried);
          }
          else if (!isNaN(prevHeight)) {
            height = prevHeight;
          }
          else {
            const h2 = await getViewer().scene.sampleHeightMostDetailed(positions);
            height = h2[0] && h2[0].height & h2[0] > projectStore.currentGPS.coords.altitude ? h2[0].height : projectStore.currentGPS.coords.altitude
          }
        }
        if (height < 0) {
          height = projectStore.currentGPS.coords.altitude ? projectStore.currentGPS.coords.altitude : 0
        }
        positions[0].height = height
        return Cartographic.toCartesian(positions[0], Ellipsoid.WGS84, new Cartesian3());
      }
      if (updatedPositions[0].height < 0) {
        return await obtSampleTerrain(lat, lon, tried);
      }
      if (updatedPositions.length)
        return Cartographic.toCartesian(updatedPositions[0], Ellipsoid.WGS84, new Cartesian3())
    }
    else {
      var f = getViewer().scene.clampToHeight(Cartesian3.fromDegrees(lon, lat), ls, 0.1, new Cartesian3())
      return f
    }
  }
  function getVisibleTilesets(visibleTilesets, modelList, hide) {

    if (visibleTilesets && visibleTilesets.length > 0) {
      return modelList.filter(function (newData) {
        return projectStore.visibleTilesets.filter(function (oldData) {
          if (newData.modelId === oldData.modelId) {
            if (hide) {

              if (!oldData.isTempHidden) {
                if (oldData.isVisible === false) {
                  newData.isVisible = false
                  newData.isVisibleClip = oldData.isVisibleClip
                }
                if (newData.isRender && oldData.isVisible) {
                  newData.isVisible = false
                  newData.isVisibleClip = oldData.isVisibleClip
                  newData.isTempHidden = true
                }
              }
              else {
                if (newData.isRender) {
                  newData.isVisible = false
                  newData.isVisibleClip = oldData.isVisibleClip
                  newData.isTempHidden = true
                }
              }
            }
            else {

              if (oldData.isTempHidden) {

                newData.isVisible = true
                newData.isVisibleClip = oldData.isVisibleClip
              }
              else {
                newData.isVisible = oldData.isVisible
                newData.isVisibleClip = oldData.isVisibleClip
              }
              newData.isTempHidden = undefined
            }
          }
        })
      });
    }
    else {
      return modelList.map(function (obj) {
        if (hide) {
          if (!obj.isTempHidden) {
            if (obj.isRender) {
              obj.isVisible = false;
              obj.isTempHidden = true
              obj.isVisibleClip = false
            }
          }
        }
        else {
          if (obj.isTempHidden) {
            obj.isVisible = true
            obj.isVisibleClip = true
          }
          obj.isTempHidden = undefined
        }
        return obj
      });
    }
  }
  // useEffect(() => {  
  //   if(projectStore.isShowARCamera){
  //     projectStore.setLoadingProgress(false)
  //   }
  // }, [projectStore.isShowARCamera])

  function setBackgroundColor() {
    if (projectStore.gpsMode === 'first_person') {

      if (projectStore.skyColor === 'cesium' || projectStore.skyColor === 'none') {
        getViewer().scene.backgroundColor = new Color(0, 0, 0, 1)
      }
      if (projectStore.skyColor === 'white') {
        getViewer().scene.backgroundColor = Color.WHITE
      }
      if (projectStore.skyColor === 'camera' || projectStore.skyColor === 'masking') {
        // if(projectStore.isShowARCamera){
        //   projectStore.setLoadingProgress(false)
        //   }
        projectStore.setOpenCVData({
          id: 0,
          angle: 999,
          apply: false,
        })

        getViewer().scene.backgroundColor = Color.TRANSPARENT
      }
    } else {
      const canvas = getViewer().canvas
      canvas.style.width = "100%"
      canvas.style.height = "100%"
    }
    getViewer().scene.backgroundColor = Color.TRANSPARENT
  }
  useEffect(() => {
    setBackgroundColor()
    if (projectStore.gpsMode === 'first_person' && projectStore.skyColor === 'cesium') {
      getViewer().scene.globe.show = true
      //commonStore.setCameraPossition(new Cartesian3(getViewer().camera._positionWC.x, getViewer().camera._positionWC.y, getViewer().camera._positionWC.z));
      commonStore.setcameraCesium({
        position: getViewer().camera.position.clone(),
        direction: getViewer().camera.direction.clone(),
        up: getViewer().camera.up.clone()
      })
    }
    var retrievedObject = JSON.parse(localStorage.getItem(`gotoviewer-${projectStore.projectDetail.id}-${usersStore.currentUser.id}`));

    if (projectStore.gpsMode === 'first_person' && (projectStore.skyColor === 'camera' || projectStore.skyColor === 'masking')) {

      if (commonStore.manualGpsState !== 1) {
        getViewer().scene.globe.show = false
        getViewer().scene.sun.show = false
        getViewer().scene.moon.show = false
        //hide tileset model has isrender = true only show on tileset isrender=false 
        let temp = toJS(projectStore.modelList).map(item => {
          let visible4DModels = retrievedObject?.visible4DModels || []
          let visibleClipModels = retrievedObject?.visibleClipModels || []
          let isExist4D = visible4DModels && visible4DModels.length > 0 ? visible4DModels.find(c => c.type4D === 'model' && c.modelId === item._id) : false
          let isExistClip = visibleClipModels && visibleClipModels.length > 0 ? visibleClipModels.find(c => c.modelId === item._id) : false
          return { modelId: item._id, isVisible: true, isRender: item.isRender, style: item.style, type: item.type, sourceType: item.sourceType, isVisible4D: (isExist4D ? isExist4D.isVisible4D : true), isVisibleClip: (isExistClip ? isExistClip.isVisibleClip : true), endDate: item.endDate, startDate: item.startDate }
        })
        let _visibletileset = getVisibleTilesets(projectStore.visibleTilesets, temp, commonStore.manualGpsState !== 1)
        projectStore.setVisibleTilesets(_visibletileset)
      }
      else {
        getViewer().scene.screenSpaceCameraController.enableInputs = true
      }
    } else {
      getViewer().scene.sun.show = true
      getViewer().scene.moon.show = true
      getViewer().scene.globe.show = true
      let temp = toJS(projectStore.modelList).map(item => {
        let visible4DModels = retrievedObject?.visible4DModels || []
        let visibleClipModels = retrievedObject?.visibleClipModels || []
        let isExist4D = visible4DModels && visible4DModels.length > 0 ? visible4DModels.find(c => c.type4D === 'model' && c.modelId === item._id) : false
        let isExistClip = visibleClipModels && visibleClipModels.length > 0 ? visibleClipModels.find(c => c.modelId === item._id) : false
        return { modelId: item._id, isVisible: true, isRender: item.isRender, style: item.style, type: item.type, sourceType: item.sourceType, isVisible4D: (isExist4D ? isExist4D.isVisible4D : true), isVisibleClip: (isExistClip ? isExistClip.isVisibleClip : true), endDate: item.endDate, startDate: item.startDate }
      })
      if (projectStore.skyColor === 'none') {
        let _visibletileset = getVisibleTilesets(projectStore.visibleTilesets, temp, false)
        projectStore.setVisibleTilesets(_visibletileset)
        projectStore.setBeforeVisibleTileset([])
      } else {
        let _visibletileset = getVisibleTilesets(projectStore.visibleTilesets, temp, false)
        projectStore.setVisibleTilesets(_visibletileset)
      }
      if (projectStore.isMasking) {
        getViewer().scene.globe.show = false
      }

      // getViewer().scene.sun.show = true
      // getViewer().scene.moon.show = true

      projectStore.setObtGPSOrientation({});
    }
    if (projectStore.gpsMode === 'first_person' && projectStore.skyColor === 'cesium') {
      getViewer().scene.globe.show = true
      //commonStore.setCameraPossition(new Cartesian3(getViewer().camera._positionWC.x, getViewer().camera._positionWC.y, getViewer().camera._positionWC.z));
      commonStore.setcameraCesium({
        position: getViewer().camera.position.clone(),
        direction: getViewer().camera.direction.clone(),
        up: getViewer().camera.up.clone()
      })
    }
    if (projectStore.gpsMode === 'first_person' && (projectStore.skyColor === 'camera' || projectStore.skyColor === 'masking')) {
      getViewer().scene.globe.show = false
      if (commonStore.manualGpsState !== 1) {

      }
      else {
        getViewer().scene.screenSpaceCameraController.enableInputs = true
      }
    } else {

      getViewer().scene.globe.show = true

      if (projectStore.skyColor === 'none') {

      } else {

      }
      if (projectStore.isMasking) {
        getViewer().scene.globe.show = false
      }
      projectStore.setObtGPSOrientation({});
    }

  }, [projectStore.skyColor])

  useEffect(() => {

    if (commonStore.useAbsoluteOrientation === false) {
      stopAllSensor()
      // getOrientation()
      // const sensor = getSensor(false)

      // //const q = new Quaternion(b[0], b[1], b[2], b[3]);
      // const hpr = getHeadingPitchRoll(sensor, true);

      // if (commonStore.manualOrientationState === 1) {
      //   if (hpr) {
      //     console.log("abs heading (deg)", CesiumMath.toDegrees(hpr.heading));
      //     projectStore.setAbsoluteHPRData([{
      //       heading: hpr.heading,
      //       pitch: hpr.pitch,
      //       roll: hpr.roll,
      //       height: hpr?.height,
      //       type: hpr?.mode
      //     }])
      //   }

      // }
    }
    else {
      if (commonStore.manualOrientationState === 0) {

        projectStore.setAbsoluteHPRData([])
      }
    }

    if (commonStore.manualOrientationState !== 1) {
      stopAllSensor()
      getOrientation()
    }

  }, [commonStore.useAbsoluteOrientation])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (commonStore.manualOrientationState === 1) {
      // const sensor = getSensor(false)
      // var hpr = getHeadingPitchRoll(sensor, true)
      // if (hpr)

      //   projectStore.setAbsoluteHPRData([...projectStore.absoluteHPRData, {
      //     heading: hpr.heading,
      //     pitch: hpr.pitch,
      //     roll: hpr.roll,
      //     height: hpr?.height,
      //     type: hpr?.mode
      //   }])
      //stopAllSensor()
      //getOrientation()
    }
    if (commonStore.manualOrientationState === 2) {
      await getOrientation()
      // const sensor = getCurrentOrientationSensor()
      // const b = sensor.quaternion;
      // //const q = new Quaternion(b[0], b[1], b[2], b[3]);
      // const hpr = getHeadingPitchRoll(sensor)
      // if (hpr)
      //   projectStore.setAbsoluteHPRData({
      //     heading: hpr.heading + projectStore.absoluteHPRData.heading,
      //     pitch: hpr.pitch + projectStore.absoluteHPRData.pitch,
      //     roll: hpr.roll + projectStore.absoluteHPRData.roll,
      //     height: hpr?.height,
      //     type: hpr?.mode
      //   })

    }
    if (commonStore.manualOrientationState === 0) {
      projectStore.setAbsoluteHPRData([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commonStore.manualOrientationState])


  useEffect(() => {
    // getViewer().scene.screenSpaceCameraController.enableInputs = projectStore.gpsMode !== 'first_person';
    // getViewer().trackedEntity = undefined
    // setBackgroundColor();
    if (projectStore.gpsMode !== 'none') {
      if (projectStore.gpsMode === 'fix' || projectStore.gpsMode === 'first_person') {
        getOrientation()
      } else if (projectStore.gpsMode === 'free') {
        ;
      } else {
        stopAllSensor()
      }

      // geoFindMe(true)
    } else {

      projectStore.setRestoreUserView3Dmode(true) // set effect restore again view of 3D before
      projectStore.setCurrentGPS({});

      var centerScreen = getCenterScreenCoordinates(getViewer())
      if (!centerScreen || !getViewer().camera) return
      var transform = Transforms.eastNorthUpToFixedFrame(centerScreen.oldPos)
      var saveCamData = {
        heading: getViewer().camera.heading,
        pitch: getViewer().camera.pitch,
        roll: getViewer().camera.roll,
      }
      
      projectStore.setObtGPSOrientation({});
      getViewer().camera.lookAtTransform(
        transform,
        new HeadingPitchRange(
          // projectStore.obtGPSOrientation.orientation.heading,
          saveCamData.heading,
          saveCamData.pitch,
          centerScreen.dis
        )
      )
      getViewer().scene.screenSpaceCameraController.enableTilt = true
      getViewer().scene.screenSpaceCameraController.enableInputs = true
      getViewer().camera.lookAtTransform(Matrix4.IDENTITY)
      // projectStore.setObtGPSOrientation({
      //   orientation: saveCamData,
      // })
      stopAllSensor()

    }
    // return () => {
    //   //stopAllSensor()
    // }
  }, [projectStore.gpsMode])

  function radians_to_degrees(radians) {
    var pi = Math.PI;
    return radians * (180 / pi);
  }
  var M_PI = Math.PI;
  // Degree to Radian conversion
  var degToRad = M_PI / 180;
  var hasScreenOrientationAPI = window.screen && window.screen.orientation && window.screen.orientation.angle !== undefined && window.screen.orientation.angle !== null ? true : false;
  var initScreenOrientationAngle = (hasScreenOrientationAPI ? window.screen.orientation.angle : (window.orientation || 0)) * degToRad;
  function onReadingSensorMotion(e, mode) {
    //console.log(mode, e)
    let q = e.target.quaternion;
    if (!getViewer().scene) return
    var a = new Quaternion(q[0], q[1], q[2], q[3])
    if (freezeCamera || commonStore.manualOrientationState === 1) {
      if (commonStore.manualOrientationState === 1) {
        var hpr = HeadingPitchRoll.fromQuaternion(a)
        if (hpr) {
          projectStore.setAbsoluteHPRData([...projectStore.absoluteHPRData, {
            heading: hpr.heading,
            pitch: hpr.pitch,
            roll: hpr.roll,
            height: hpr?.height,
            type: hpr?.mode
          }])
        }
      }
      return
    }
    //var hpr = HeadingPitchRoll.fromQuaternion(a)
    //updateGPSPosition()
    const sensor = getCurrentOrientationSensor()
    var position = projectStore.currentGPS
    if (position.coords) {
      const longitude = typeof position.coords.longitude === 'string' ? parseFloat(position.coords.longitude) : position.coords.longitude;
      const latitude = typeof position.coords.latitude === 'string' ? parseFloat(position.coords.latitude) : position.coords.latitude;
      var pos = Cartesian3.fromDegrees(
        longitude,
        latitude
      )
      var hpr = getHeadingPitchRoll({
        sensor, isAbsolute: commonStore.useAbsoluteOrientation
      })

      var height = (projectStore.obtGPSHeight && projectStore.obtGPSHeight.height ? projectStore.obtGPSHeight.height : projectStore.currentGPS?.coords?.altitude) || 0;
      var prvLat = latitude // projectStore.obtGPSHeight && !isNaN(projectStore.obtGPSHeight.lat) ? projectStore.obtGPSHeight.lat : latitude;
      var prvLon = longitude//projectStore.obtGPSHeight && !isNaN(projectStore.obtGPSHeight.lon) ? projectStore.obtGPSHeight.lon : longitude;
      if (prvLat && prvLon) {
        var f1 = Cartographic.toCartesian(Cartographic.fromDegrees(prvLon, prvLat, height + 2), Ellipsoid.WGS84, new Cartesian3());
        var f = Cartographic.toCartesian(Cartographic.fromDegrees(prvLon, prvLat, height), Ellipsoid.WGS84, new Cartesian3());
        if (projectStore.gpsMode === 'first_person') {

          if (hpr) {

            if (!sensor || !sensor.activated) {
              alert('sensor not started')
              return
            }

            projectStore.setObtGPSOrientation({
              heading: hpr.heading,
              //pitch: getViewer().camera && getViewer().camera.pitch ? getViewer().camera.pitch : 0,
              pitch: hpr.pitch,
              roll: hpr.roll,
              // distance: distance,
              position: f,
              height: height,
              type: mode
            })
            var averageOrientation = projectStore.averageOrientation;
            var viewOptions = {}
            if (isFirefox) {
              viewOptions.orientation = {
                heading: ((averageOrientation.heading || hpr.heading) - CesiumMath.PI / 2),
                pitch: (averageOrientation.roll ? (averageOrientation.roll - CesiumMath.PI / 2) : (hpr.roll - CesiumMath.PI / 2)),
                roll: (averageOrientation.pitch ? (averageOrientation.pitch) : (hpr.pitch)),
              }
            }
            if (isIOSCheck || isIOS) {

              var screenOrientationAngle = (hasScreenOrientationAPI ? window.screen.orientation.angle : (window.orientation || 0)) * degToRad;
              var offsetAlpha = initScreenOrientationAngle === 0 ? CesiumMath.PI / 2 : CesiumMath.PI;
              if (screenOrientationAngle === 0) {
                viewOptions.orientation = {
                  heading: ((averageOrientation.heading || hpr.heading) - offsetAlpha),
                  pitch: (averageOrientation.roll ? (averageOrientation.roll - CesiumMath.PI / 2) : (hpr.roll - CesiumMath.PI / 2)),
                  roll: (averageOrientation.pitch ? (averageOrientation.pitch) : (hpr.pitch)),
                }
              }
              else {
                viewOptions.orientation = {
                  heading: ((averageOrientation.heading || hpr.heading) - offsetAlpha),
                  pitch: (averageOrientation.roll ? (averageOrientation.roll - CesiumMath.PI / 2) : (hpr.roll - CesiumMath.PI / 2)),
                  roll: (averageOrientation.pitch ? (averageOrientation.pitch - CesiumMath.PI) : (hpr.pitch - CesiumMath.PI)),
                }
              }

            }
            else {
              viewOptions.orientation = {
                heading: ((averageOrientation.heading || hpr.heading) + CesiumMath.PI),
                pitch: (averageOrientation.roll ? (averageOrientation.roll - CesiumMath.PI / 2) : (hpr.roll - CesiumMath.PI / 2)),
                roll: (averageOrientation.pitch ? (averageOrientation.pitch) : (hpr.pitch)),
              }
            }

          }
          if (hpr && f && position.coords) {
            //let distance = Cartesian3.distance(getViewer().camera._positionWC, f);
            //if (distance > 2.5) {
            viewOptions.destination = f1
            //}

            //Record all data
            if (projectStore.startRecordData) {
              let hpr1 = { ...hpr, timeStamp: Math.round(new Date() / 1000) }
              let position1 = { ...position.coords, timeStamp: Math.round(new Date() / 1000) }
              let averageOrientation1 = { ...averageOrientation, timeStamp: Math.round(new Date() / 1000) }

              projectStore.setRecordData({
                position: [...projectStore.recordData.position, position1],
                sensorRawData: [...projectStore.recordData.sensorRawData, hpr1],
                dataAfterSmoothingFiltering: [...projectStore.recordData.dataAfterSmoothingFiltering, averageOrientation1]
              })
            }
          }
          if (commonStore.manualGpsState === 1) {
            getViewer().scene.screenSpaceCameraController.enableInputs = true
            return
          }
          else {
            getViewer().scene.screenSpaceCameraController.enableInputs = projectStore.gpsMode !== 'first_person';
          }
          getViewer().camera.setView(viewOptions)
        }
        else {
          if (projectStore.gpsMode === 'fix' && hpr && f) {
            let distance = Cartesian3.distance(getViewer().scene.camera._positionWC, f)
            if(distance > 100){
              getViewer().camera.lookAt(f, new HeadingPitchRange(hpr.heading + CesiumMath.PI, getViewer().camera.pitch, 100));
            }
            else {
              getViewer().camera.lookAt(f, new HeadingPitchRange(hpr.heading + CesiumMath.PI, getViewer().camera.pitch, distance));
            }
            
            //getViewer().camera.lookAtTransform(Matrix4.IDENTITY);
            //}
            projectStore.setObtGPSOrientation({
              heading: hpr.heading,
              //pitch: getViewer().camera && getViewer().camera.pitch ? getViewer().camera.pitch : 0,
              pitch: hpr.pitch,
              roll: hpr.roll,
              distance: distance,
              position: f,
              height: height
            })
          }
        }
      }

      // var clamp = false
      // obtSampleTerrain(latitude, longitude).then(function (f) {
      //   if (!getViewer().camera) return

      //   if (f) { clamp = true }
      //   var g = Cartographic.fromCartesian(f || pos, Ellipsoid.WGS84, new Cartographic())
      //   //HeadingPitchRoll.fromQuaternion(viewQuaternion, hpr)

      // })
    }
  }
  const isIOSCheck = /iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  async function createMotionTracking() {
    const sensor = getCurrentOrientationSensor()
    if (!sensor || !sensor.activated || !sensor.start) {
      try {
        if ((isIOS || isIOSCheck) && typeof DeviceMotionEvent.requestPermission === 'function') {
          try {
            const permissionStatus = await DeviceOrientationEvent.requestPermission();
            if (permissionStatus !== 'granted') {
              setvisiblePermission(true);
            }
            else {
              handlePermissionOk()
            }
          } catch (error) {
            setvisiblePermission(true);
          }

        }
        else if (isFirefox || projectStore.compassMode === 'b') {
          //else {
          var iosAGyro = new VRGyro("world");
          iosAGyro.addEventListener("reading", function (e) { onReadingSensorMotion(e, 'absolute') });
          projectStore.setobtAbsoluteDeviceSensor(iosAGyro);

          var iosRGyro = new VRGyro("game");
          iosRGyro.addEventListener("reading", function (e) { onReadingSensorMotion(e, 'relative') });
          projectStore.setobtRelativeDeviceSensor(iosRGyro);
          //TODO
        }
        else {
          const sensorAbsolute = new AbsoluteOrientationSensor({
            frequency: projectStore.sensorFrequences,
            referenceFrame: "screen"
          })
          sensorAbsolute.type = 'world'
          sensorAbsolute.addEventListener("reading", function (e) { onReadingSensorMotion(e, 'absolute') });
          projectStore.setobtAbsoluteDeviceSensor(sensorAbsolute)

          const sensorRelative = new RelativeOrientationSensor({
            frequency: projectStore.sensorFrequences,
            referenceFrame: "screen"
          })
          sensorRelative.addEventListener("reading", function (e) { onReadingSensorMotion(e, 'relative') });
          projectStore.setobtRelativeDeviceSensor(sensorRelative)
        }
        //       compassMode = 'a'
        // setCompassMode
        // else {

        //   var firstTime = true;

        // }
        //sensor.start();

        if (projectStore.gpsMode === 'fix' || projectStore.gpsMode === 'first_person') {
          getOrientation()
        }
        //   await FULLTILT.getDeviceOrientation({
        //     type: 'world',
        //   })
        // )
      } catch (d) {
        if ("SecurityError" === d.name)
          console.log("Sensor construction was blocked by a feature policy.");
        else if ("ReferenceError" === d.name)
          console.log("Sensor is not supported by the User Agent.");
        else {
          alert(d);
        }
      }
    }
  }

  function stopWatch() {

    navigator.geolocation.clearWatch(projectStore.geoWatch);
    projectStore.setGeoWatch(undefined)
  }

  function positionError(error) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        console.error(t('user-denied-the-request-for-geolocation'));
        break;
      case error.POSITION_UNAVAILABLE:
        console.error(t('location-information-is-unavailable'));
        break;
      case error.TIMEOUT:
        console.error(t('the-request-to-get-user-location-timed-out'));
        break;
      case error.UNKNOWN_ERROR:
        console.error(t('an-unknown-error-occurred'));
        break;
    }
    //alert('positionError ' + error.code)
  }

  function startWatch() {
    if ("geolocation" in navigator && "watchPosition" in navigator.geolocation) {
      if (projectStore.geoWatch && !isNaN(projectStore.geoWatch)) {
        navigator.geolocation.clearWatch(projectStore.geoWatch)
      }

      var geoWatch = navigator.geolocation.watchPosition(updateGPSPosition,
        positionError, {
        enableHighAccuracy: commonStore.enableHighAccuracy,
        timeout: 30000,
        maximumAge: 30000
      });

      projectStore.setGeoWatch(geoWatch)
    }
  }
  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time)
    )
  }
  useEffect(() => {

    if (!getViewer().scene) return
    //geoFindMe(true)
    startWatch()
    // sleep(1000).then(() => {

    //   createMotionTracking()
    // })


    if (!projectStore.WorldTerrain) {
      //projectStore.setWorldTerrain(createWorldTerrain());
    }

    return () => {
      stopWatch();
      stopAllSensor()
    }
  }, [])

  const getImageFromCanvas = async (filename) => {
    if (getViewer() !== null) {
      getViewer().render()
      const canvas = getViewer().canvas
      const base64Image = canvas.toDataURL('image/jpeg', 0.5) // 1.0 fullQuality, 0.5 mediumQuality , 0.1 lowQuality 
      const imageFile = await createImageFileFromBase64(base64Image, filename, false)
      const formData = new FormData()
      formData.append('files', imageFile)
      return ProjectRequest.uploadModel(formData)
    }
    return Promise.reject()
  }

  const takePhotoFromDevice = async (filename) => {
    if (webcamRef.current !== null) {
      getViewer().render()
      if (webcamRef.current.canvas) {
        let ratio = getViewer().camera.frustum.aspectRatio
        let _width = webcamRef.current.canvas.width
        let _height = webcamRef.current.canvas.height
        if (ratio >= 1 && _height > _width) {
          webcamRef.current.canvas.width = _height
          webcamRef.current.canvas.height = _width
        }
        if (ratio < 1 && _width > _height) {
          webcamRef.current.canvas.width = _height
          webcamRef.current.canvas.height = _width
        }
      }

      const imageSrc = webcamRef.current.getScreenshot();
      if (imageSrc) {
        const imageFile = await createImageFileFromBase64(imageSrc, filename, false)
        const formData = new FormData()
        formData.append('files', imageFile)
        return ProjectRequest.uploadModel(formData)
      }
      return
    }
    return Promise.reject()
  }

  const getCameraDataAR = async (camData) => {
    if (viewer.current != null) {
      var currentFOV = getViewer().camera.frustum.fov

      var degree = CesiumMath.toDegrees(currentFOV);
      camData.FOV = degree
      /** capture render model*/
      const temp1 = projectStore.visibleTilesets

      //hide model design model, show model existing data
      var primitives = getViewer().scene.primitives._primitives.filter(function (value, index, arr) {
        return value.isCesium3DTileset;
      });
      for (var i = 0; i < primitives.length; i++) {
        var _tileset = primitives[i]
        var model = projectStore.findModelByUrl(_tileset?.resource?.url)
        if (model && model.isRender) {
          _tileset.style = new Cesium3DTileStyle({
            //pointSize: 8,
          })
        }
        if (model && !model.isRender) {
          _tileset.style = new Cesium3DTileStyle({
            //pointSize: 8,
            color: "color('white', 0)",
            show: true,
          })
        }
      }

      let modelrenderdata = {
        OpenCV: {
          extra: projectStore.openCVData.extra,
          hc: projectStore.openCVData.hc,
          vc: projectStore.openCVData.vc
        }
      }
      // var ratio = getViewer().camera.frustum.aspectRatio
      let canvas = getViewer().canvas
      modelrenderdata.CanvasSize = {
        width: canvas.width,
        height: canvas.height,
      }
      modelrenderdata.CesiumCameraData = camData
      // capturesStore.setCameraData(camData)

      let flyOption = {}
      if (camData.position) {
        let destination = new Cartesian3(
          camData.position.x,
          camData.position.y,
          camData.position.z
        )
        flyOption.destination = destination
      }

      // if (camData.orientation) {
      flyOption.orientation = camData.orientation
      // } else {
      //   if (camData.direction) {
      //     let direction = new Cartesian3(
      //       camData.direction.x,
      //       camData.direction.y,
      //       camData.direction.z
      //     )
      //     let up = new Cartesian3(camData.up.x, camData.up.y, camData.up.z)
      //     flyOption.orientation = {
      //       direction,
      //       up,
      //     }
      //   }
      // }
      // getViewer().camera.flyTo(flyOption)
      getViewer().camera.setView(flyOption)

      const files = await getImageFromCanvas(`ModelImage${new Date().getTime() / 1000}.jpeg`)
      const file = files.data[0]
      let _modelrender = {
        imageModelRender: file,
        modelRenderInfo: modelrenderdata
      }
      projectStore.setVisibleTilesets(temp1)
      capturesStore.setCameraData(false)

      // //reset hc, vc
      // projectStore.setOpenCVData({ hc: 0, vc: 0 })

      //show again design model, hide model existing data
      for (var i = 0; i < primitives.length; i++) {
        var _tileset = primitives[i]
        var model = projectStore.findModelByUrl(_tileset?.resource?.url)
        if (model && model.isRender) {
          _tileset.style = new Cesium3DTileStyle({
            //pointSize: 8,
            color: "color('white', 0)",
            show: true,
          })
        }
        if (model && !model.isRender) {
          // _tileset.style = new Cesium3DTileStyle({
          //   pointSize: 8,
          // })
        }
      }

      return _modelrender
    }
    return false
  }

  const getDevicePhoto = async (headingpitroll) => {
    if (viewer.current != null && headingpitroll) {
      let _deviceinfo = {}
      let _headingpitroll = headingpitroll
      var position = projectStore.currentGPS
      let _pos = new Cartesian3.fromDegrees(0, 0)

      if (position) {
        _pos = Cartesian3.fromDegrees(
          position.coords.longitude,
          position.coords.latitude
        )
      }
      _deviceinfo.position = _pos
      _deviceinfo = Object.assign(_headingpitroll, _deviceinfo)

      //reset camera
      if (projectStore.openCVData.apply) {
        var initVAngle = 0
        var initHAngle = 0
        if (projectStore.openCVData.angle != 999) {
          initHAngle = -projectStore.openCVData.hc
        }
        if (projectStore.openCVData.vAngle != 999) {
          initVAngle = -projectStore.openCVData.vc
        }
        rotateCamera(getViewer(), initHAngle, initVAngle)
      }

      let camera = getViewer().camera
      let camData = {}
      camData.duration = 0
      camData.position = {
        x: camera.position.x,
        y: camera.position.y,
        z: camera.position.z,
      }
      camData.direction = {
        x: camera.direction.x,
        y: camera.direction.y,
        z: camera.direction.z,
      }
      camData.up = {
        x: camera.up.x,
        y: camera.up.y,
        z: camera.up.z,
      }
      camData.orientation = {
        heading: getViewer().camera.heading,
        pitch: getViewer().camera.pitch,
        roll: getViewer().camera.roll
      }
      let _device = {}
      _device.devicecapture = {
        deviceInfo: _deviceinfo
      }

      let files = await takePhotoFromDevice(`photoDevice${new Date().getTime() / 1000}.jpeg`)
      let file = (files && files.data[0]) ? files.data[0] : ''
      _device.devicecapture.photoDevice = file
      _device.camData = camData

      return _device
    }
    return false
  }

  useEffect(() => {
    // const SendARCaptureData = async () => {
    //   // projectStore.openCVData.apply = false
    //   // projectStore.openCVData.angle = 0
    //   projectStore.setLoadingProgress(true)
    //   getViewer().scene.backgroundColor = Color.WHITE
    //   setFreezeCamera(true)
    //   // const isMasking = projectStore.isMasking;
    //   // if(isMasking)
    //   //   projectStore.setMasking(false)
    //   stopWatch()
    //   const sensor = getCurrentOrientationSensor()
    //   let _hpr = getHeadingPitchRoll({ sensor, isAbsolute: commonStore.useAbsoluteOrientation })
    //   let devicephoto = await getDevicePhoto(_hpr)
    //   if (devicephoto) {
    //     let capturemodelrender = await getCameraDataAR(devicephoto.camData)

    //     var d = new Date(); // Today!

    //     let newCapture = {
    //       name: 'AR Capture - ' + d.toDateString() + '-' + d.getHours() + 'h' + d.getMinutes(),
    //       project: projectid,
    //     }
    //     let params = Object.assign(newCapture, capturemodelrender, devicephoto.devicecapture)
    //     await projectStore.sendARInfo(params)
    //     projectStore.setSendARInfo(false)
    //     projectStore.setLoadingProgress(false)
    //     getViewer().scene.backgroundColor = Color.TRANSPARENT
    //     startWatch()
    //     setFreezeCamera(false)
    //   } else {
    //     projectStore.setSendARInfo(false)
    //     projectStore.setLoadingProgress(false)
    //     notification.open({
    //       message: t('calibration'),
    //       description: t('error-with-camera-requested-device-not-found')
    //     })
    //   }
    //   // if(isMasking)
    //   //   projectStore.setMasking(true)
    // }

    // if (projectStore.isSendARInfo) {
    //   // SendARCaptureData()
    //   // projectStore.setSendARInfo(false)
    //   let _existcitymodel = projectStore.getTilesetExistCityModel(getViewer())
    //   if (_existcitymodel.length > 0) {
    //     let _num = 0
    //     for (var i = 0; i < _existcitymodel.length; i++) {
    //       if (_existcitymodel[i].tilesLoaded) {
    //         _num = _num + 1
    //       }
    //     }
    //     if (_num === _existcitymodel.length) {
    //       SendARCaptureData()
    //     } else {
    //       const closeMsg = () => {
    //         SendARCaptureData()
    //       };
    //       const btn = (
    //         <Button type="primary" size="small" onClick={
    //           () => {
    //             notification.close('n01')
    //             closeMsg()
    //           }
    //         }>
    //           Skip
    //         </Button>
    //       );

    //       notification.destroy()
    //       notification.open({
    //         message: t('calibration'),
    //         description: t('if-calibration-is-not-successful-you-may-need-to-wait-a-bit-to-get-city-model-loaded'),
    //         onClose: closeMsg,
    //         key: 'n01',
    //         btn,
    //         icon: <Spin />,
    //       })
    //       projectStore.setSendARInfo(false)
    //     }
    //   } else {
    //     SendARCaptureData()
    //   }
    // }
  }, [projectStore.isSendARInfo])

  return (
    <>
      <Entity
        position={markerPos}
        billboard={greenPin}
        show={projectStore.gpsMode !== 'none'}
        ref={pinRef}
      />
      <Modal
        title={t('permission')}
        visible={visiblePermission}
        onOk={handlePermissionOk}
        onCancel={handlePermissionCancel}
      >
        <p> This immersive website requires access to your device sensors.</p>
      </Modal>
    </>
  )
}
export default inject('projectStore', 'commonStore', 'capturesStore', 'usersStore')(observer(Gps))
